import * as React from "react";
function SvgShop(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M43.5 26.1c-.8 0-1.5.7-1.5 1.5v5.9H6v-6c0-.8-.7-1.5-1.5-1.5S3 26.7 3 27.5v15.2c.1 1.5 1.4 2.8 3 2.8h36c1.6 0 2.9-1.2 3-2.9v-15c0-.8-.7-1.5-1.5-1.5zM6 42.6v-6.1h36v6l-36 .1zm42-28.2c.1-.4 0-.8-.2-1.1L40.2 2.6c-.3-.4-.7-.6-1.2-.6H9c-.5 0-.9.2-1.2.6L.3 13.3c-.3.3-.3.7-.3 1.1v2.8c-.1 3.9 2.9 7.1 6.9 7.3h.5a7.2 7.2 0 005.5-2.9c1.2 1.7 3.2 2.9 5.5 2.9h.5c2.2-.1 4.1-1.2 5.3-2.8 1.2 1.6 3.2 2.7 5.4 2.8h.5c2.1-.1 4-1.2 5.2-2.8 1.3 1.6 3.2 2.7 5.4 2.8h.5c3.9-.1 6.9-3.4 6.8-7.2V14.4zm-6.9 7.1h-.4c-2.2-.1-4-1.9-3.9-4.2v-.1c0-.1 0-.2-.1-.3 0-.1 0-.2-.1-.3 0-.1-.1-.2-.2-.2-.1-.1-.1-.2-.2-.2-.1-.1-.1-.1-.2-.1.1-.1 0-.1-.1-.2h-.2c-.1 0-.2-.1-.3-.1h-.2c-.1 0-.3 0-.4.1h-.1c-.1.1-.3.2-.4.3l-.1.1c-.1.1-.2.2-.2.3 0 .1 0 .2-.1.3 0 .1-.1.2-.1.3v.1c.1 2.2-1.7 4.1-3.8 4.2h-.4c-2.2-.1-4-1.9-3.9-4.2 0-.7-.4-1.2-1-1.4-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.3.1h-.1c-.6.2-1 .8-1 1.4a4.1 4.1 0 01-3.9 4.2h-.4c-2.2-.1-4-1.9-3.9-4.2 0-.8-.6-1.5-1.5-1.5h-.4c-.8 0-1.5.7-1.5 1.5a4.1 4.1 0 01-3.9 4.2h-.4c-2.2-.1-4-1.9-3.9-4.2v-2.7L9.8 5h28.4l6.8 9.6v2.7c.1 2.3-1.7 4.1-3.9 4.2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgShop);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
